import React, { FC } from "react";
import { Button } from "@mui/material";
import AddShoppingCart from "@mui/icons-material/AddShoppingCart";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { styled } from "@mui/material/styles";
import Preview from "../Canvas/Preview/Preview";
import { isMobile } from "../../pages/DealerZone/dealerZone.biz";
import useBtnSelection from "./useBtnSelection";

const StyledCancelButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(5),
  flexBasis: "80%",
  color: "white",
  position: "fixed",
  bottom: 120,
  right: -25,
  zIndex: 50,
  width: 169,
}));

const StyledSubmitButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(5),
  flexBasis: "80%",
  color: "white",
}));

const StyledEditButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(5),
  flexBasis: "80%",
  color: "white",
  position: "fixed",
  bottom: 60,
  right: -25,
  zIndex: 50,
  width: 169,
}));

const StyledPreviewButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(5),
  flexBasis: "80%",
  // color: "#4b4b4b",
  position: "fixed",
  bottom: 0,
  right: -25,
  zIndex: 50,
  width: 169,
  fontWeight: "bold",
}));

const StyledMinimizeButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(5),
  flexBasis: "20%",
  color: "white",
}));

interface ConfigBtnsProps {
  resetValues: () => void;
  addDoorToSidebar: (withCheck?: boolean, ignoreUnitCheck?: boolean) => void;
}

const ConfiguratorBtns: FC<ConfigBtnsProps> = ({
  resetValues,
  addDoorToSidebar,
}) => {
  const {
    btnDisabled,
    showPrevBtn,
    openPreview,
    showPortal,
    setOpenPreview,
    setShowPortal,
    editBtn,
    handleMinimize,
  } = useBtnSelection();

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      {editBtn ? (
        <>
          <StyledCancelButton
            variant="contained"
            size="large"
            color="customGrey"
            onClick={resetValues}
          >
            Cancel Update
          </StyledCancelButton>

          <StyledEditButton
            variant="contained"
            color="primary"
            size="large"
            startIcon={<AddShoppingCart />}
            onClick={() => addDoorToSidebar(true)}
            disabled={btnDisabled}
          >
            Update Unit
          </StyledEditButton>
        </>
      ) : (
        <StyledSubmitButton
          variant="contained"
          color="primary"
          size="large"
          startIcon={<AddShoppingCart />}
          onClick={() => addDoorToSidebar(true)}
          disabled={btnDisabled}
        >
          Add to Quote
        </StyledSubmitButton>
      )}

      {showPrevBtn && (
        <>
          <StyledPreviewButton
            variant={editBtn ? "outlined" : "contained"}
            color="customGrey"
            style={{
              backgroundColor: editBtn ? "whitesmoke" : "",
              color: editBtn ? "#4b4b4b" : "white",
            }}
            size="large"
            startIcon={<VisibilityIcon />}
            onClick={
              isMobile()
                ? () => setShowPortal(true)
                : () => setOpenPreview(true)
            }
            disabled={openPreview || showPortal ? true : false}
          >
            2D Preview
          </StyledPreviewButton>

          <Preview
            open={openPreview}
            setOpen={setOpenPreview}
            showPortal={showPortal}
            setShowPortal={setShowPortal}
          />
        </>
      )}

      <StyledMinimizeButton
        variant="contained"
        size="large"
        color="customGrey"
        onClick={handleMinimize}
      >
        Minimize Tabs
      </StyledMinimizeButton>
    </div>
  );
};

export default ConfiguratorBtns;
